"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _Content2.default;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header2.default;
  }
});
Object.defineProperty(exports, "HeaderContainer", {
  enumerable: true,
  get: function get() {
    return _HeaderContainer2.default;
  }
});
Object.defineProperty(exports, "HeaderGlobalAction", {
  enumerable: true,
  get: function get() {
    return _HeaderGlobalAction2.default;
  }
});
Object.defineProperty(exports, "HeaderGlobalBar", {
  enumerable: true,
  get: function get() {
    return _HeaderGlobalBar2.default;
  }
});
Object.defineProperty(exports, "HeaderMenu", {
  enumerable: true,
  get: function get() {
    return _HeaderMenu2.default;
  }
});
Object.defineProperty(exports, "HeaderMenuButton", {
  enumerable: true,
  get: function get() {
    return _HeaderMenuButton2.default;
  }
});
Object.defineProperty(exports, "HeaderMenuItem", {
  enumerable: true,
  get: function get() {
    return _HeaderMenuItem2.default;
  }
});
Object.defineProperty(exports, "HeaderName", {
  enumerable: true,
  get: function get() {
    return _HeaderName2.default;
  }
});
exports.HeaderNavigation = void 0;
Object.defineProperty(exports, "HeaderPanel", {
  enumerable: true,
  get: function get() {
    return _HeaderPanel2.default;
  }
});
Object.defineProperty(exports, "HeaderSideNavItems", {
  enumerable: true,
  get: function get() {
    return _HeaderSideNavItems2.default;
  }
});
Object.defineProperty(exports, "SideNav", {
  enumerable: true,
  get: function get() {
    return _SideNav2.default;
  }
});
Object.defineProperty(exports, "SideNavDetails", {
  enumerable: true,
  get: function get() {
    return _SideNavDetails2.default;
  }
});
Object.defineProperty(exports, "SideNavDivider", {
  enumerable: true,
  get: function get() {
    return _SideNavDivider2.default;
  }
});
Object.defineProperty(exports, "SideNavFooter", {
  enumerable: true,
  get: function get() {
    return _SideNavFooter2.default;
  }
});
Object.defineProperty(exports, "SideNavHeader", {
  enumerable: true,
  get: function get() {
    return _SideNavHeader2.default;
  }
});
Object.defineProperty(exports, "SideNavIcon", {
  enumerable: true,
  get: function get() {
    return _SideNavIcon2.default;
  }
});
Object.defineProperty(exports, "SideNavItem", {
  enumerable: true,
  get: function get() {
    return _SideNavItem2.default;
  }
});
Object.defineProperty(exports, "SideNavItems", {
  enumerable: true,
  get: function get() {
    return _SideNavItems2.default;
  }
});
Object.defineProperty(exports, "SideNavLink", {
  enumerable: true,
  get: function get() {
    return _SideNavLink2.default;
  }
});
Object.defineProperty(exports, "SideNavLinkText", {
  enumerable: true,
  get: function get() {
    return _SideNavLinkText2.default;
  }
});
exports.SideNavMenu = void 0;
Object.defineProperty(exports, "SideNavMenuItem", {
  enumerable: true,
  get: function get() {
    return _SideNavMenuItem2.default;
  }
});
Object.defineProperty(exports, "SideNavSwitcher", {
  enumerable: true,
  get: function get() {
    return _SideNavSwitcher2.default;
  }
});
Object.defineProperty(exports, "SkipToContent", {
  enumerable: true,
  get: function get() {
    return _SkipToContent2.default;
  }
});
Object.defineProperty(exports, "Switcher", {
  enumerable: true,
  get: function get() {
    return _Switcher2.default;
  }
});
Object.defineProperty(exports, "SwitcherDivider", {
  enumerable: true,
  get: function get() {
    return _SwitcherDivider2.default;
  }
});
Object.defineProperty(exports, "SwitcherItem", {
  enumerable: true,
  get: function get() {
    return _SwitcherItem2.default;
  }
});

var FeatureFlags = _interopRequireWildcard(require("@carbon/feature-flags"));

var _HeaderNavigation = _interopRequireDefault(require("./HeaderNavigation"));

var _next = require("./next");

var _SideNavMenu = _interopRequireDefault(require("./SideNavMenu"));

var _SideNavMenu2 = require("./next/SideNavMenu");

var _Content2 = _interopRequireDefault(require("./Content"));

var _Header2 = _interopRequireDefault(require("./Header"));

var _HeaderContainer2 = _interopRequireDefault(require("./HeaderContainer"));

var _HeaderGlobalAction2 = _interopRequireDefault(require("./HeaderGlobalAction"));

var _HeaderGlobalBar2 = _interopRequireDefault(require("./HeaderGlobalBar"));

var _HeaderMenu2 = _interopRequireDefault(require("./HeaderMenu"));

var _HeaderMenuButton2 = _interopRequireDefault(require("./HeaderMenuButton"));

var _HeaderMenuItem2 = _interopRequireDefault(require("./HeaderMenuItem"));

var _HeaderName2 = _interopRequireDefault(require("./HeaderName"));

var _HeaderPanel2 = _interopRequireDefault(require("./HeaderPanel"));

var _HeaderSideNavItems2 = _interopRequireDefault(require("./HeaderSideNavItems"));

var _Switcher2 = _interopRequireDefault(require("./Switcher"));

var _SwitcherItem2 = _interopRequireDefault(require("./SwitcherItem"));

var _SwitcherDivider2 = _interopRequireDefault(require("./SwitcherDivider"));

var _SkipToContent2 = _interopRequireDefault(require("./SkipToContent"));

var _SideNav2 = _interopRequireDefault(require("./SideNav"));

var _SideNavDetails2 = _interopRequireDefault(require("./SideNavDetails"));

var _SideNavDivider2 = _interopRequireDefault(require("./SideNavDivider"));

var _SideNavFooter2 = _interopRequireDefault(require("./SideNavFooter"));

var _SideNavHeader2 = _interopRequireDefault(require("./SideNavHeader"));

var _SideNavIcon2 = _interopRequireDefault(require("./SideNavIcon"));

var _SideNavItem2 = _interopRequireDefault(require("./SideNavItem"));

var _SideNavItems2 = _interopRequireDefault(require("./SideNavItems"));

var _SideNavLink2 = _interopRequireDefault(require("./SideNavLink"));

var _SideNavLinkText2 = _interopRequireDefault(require("./SideNavLinkText"));

var _SideNavMenuItem2 = _interopRequireDefault(require("./SideNavMenuItem"));

var _SideNavSwitcher2 = _interopRequireDefault(require("./SideNavSwitcher"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


var HeaderNavigation = FeatureFlags.enabled('enable-v11-release') ? _next.HeaderNavigation : _HeaderNavigation.default;
exports.HeaderNavigation = HeaderNavigation;
var SideNavMenu = FeatureFlags.enabled('enable-v11-release') ? _SideNavMenu2.SideNavMenu : _SideNavMenu.default;
exports.SideNavMenu = SideNavMenu;